import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import { Spinner } from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Modal from "react-modal";
import CountryList from "../../CountryList";
import { googleApi } from "../../../services/api";
import { FaSearch } from "react-icons/fa";

// Registering Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Modal styles
const customStyles = {
  content: {
    top: "55%",
    left: "57%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "90%",
    overflow: "hidden",
  },
};
const KeywordSearch = () => {
  const [keyword, setKeyword] = useState("");
  const [country, setCountry] = useState("");
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedChartData, setSelectedChartData] = useState(null);

const stopWords = [
  "a",
  "an",
  "the",
  "i",
  "me",
  "my",
  "mine",
  "you",
  "your",
  "yours",
  "he",
  "him",
  "his",
  "she",
  "her",
  "hers",
  "it",
  "its",
  "we",
  "us",
  "our",
  "ours",
  "they",
  "them",
  "their",
  "theirs",
  "who",
  "whom",
  "whose",
  "and",
  "but",
  "or",
  "nor",
  "for",
  "so",
  "yet",
  "either",
  "neither",
  "both",
  "than",
  "that",
  "as",
  "while",
  "although",
  "because",
  "if",
  "unless",
  "whether",
  "in",
  "on",
  "at",
  "to",
  "of",
  "from",
  "by",
  "about",
  "as",
  "with",
  "between",
  "over",
  "under",
  "above",
  "below",
  "across",
  "through",
  "during",
  "before",
  "after",
  "against",
  "without",
  "within",
  "is",
  "are",
  "was",
  "were",
  "be",
  "been",
  "being",
  "have",
  "has",
  "had",
  "do",
  "does",
  "did",
  "will",
  "shall",
  "can",
  "could",
  "may",
  "might",
  "must",
  "ought",
  "need",
  "very",
  "too",
  "just",
  "only",
  "also",
  "even",
  "still",
  "yet",
  "then",
  "now",
  "here",
  "there",
  "back",
  "forward",
  "further",
  "more",
  "less",
  "once",
  "again",
  "oh",
  "ah",
  "uh",
  "hmm",
  "wow",
  "yay",
  "oops",
  "hey",
  "alas",
  "some",
  "any",
  "no",
  "none",
  "all",
  "most",
  "few",
  "several",
  "many",
  "much",
  "each",
  "every",
  "either",
  "neither",
  "a lot",
  "this",
  "that",
  "these",
  "those",
  "which",
  "what",
  "where",
  "when",
  "how",
  "why",
  "what",
  "how",
  "whoever",
  "whatever",
  "whenever",
  "wherever",
  "whichever",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
  "twenty",
  "there",
  "here",
  "back",
  "up",
  "down",
  "out",
  "in",
  "off",
  "over",
  "under",
  "along",
  "despite",
  "since",
  "let",
  "us",
  "let’s",
  "got",
  "get",
  "gotta",
  "gonna",
  "wanna",
  "have to",
  "used to",
  "be able to",
  "he's",
  "she's",
  "it's",
  "they're",
  "we're",
  "you're",
  "who's",
  "what's",
  "where's",
  "when's",
  "how's",
  "let's",
  "ain't",
  "won't",
  "can't",
  "doesn't",
  "don't",
  "didn't",
  "even",
  "just",
  "only",
  "merely",
  "simply",
  "actually",
  "really",
  "truly",
  "especially",
  "particularly",
];

  const extractKeywords = (description) => {
    // Remove URLs, HTML tags, special characters (including dots), and numbers
    const cleanedDescription = description
      .replace(/https?:\/\/[^\s]+/g, '') // Remove URLs
      .replace(/<[^>]+>/g, '') // Remove HTML tags
      .replace(/[^\w\s]|_/g, '') // Remove special characters (except whitespace)
      .replace(/\d+/g, '') // Remove numbers
      .replace(/\s+/g, ' ') // Normalize whitespace
      .trim(); // Remove leading and trailing whitespace

    const words = cleanedDescription.toLowerCase().split(/\s+/);
    const keywords = words.filter(
      (word) => word.length > 2 && !stopWords.includes(word)
    );
    const keywordFrequency = {};
    keywords.forEach((word) => {
      keywordFrequency[word] = (keywordFrequency[word] || 0) + 1;
    });
    return keywordFrequency;
  };

  const handleSearch = async () => {
    setError("");
    if (!keyword || !country) {
      setError("Please fill in all fields.");
      return;
    }

    setLoading(true);
    try {
      const response = await googleApi.post("keyword-search/", { keyword, country });
      const formattedResults = response.data.map((app) => {
        const extractedKeywords = extractKeywords(app.description || "");
        return {
          appId: app.appId || "N/A",
          title: app.title || "N/A",
          screenshot: app.icon || "N/A",
          keywords: extractedKeywords,
          installs: app.installs !== undefined ? app.installs : "N/A",
          score: app.score !== undefined ? app.score : "N/A",
          free: app.free !== undefined ? app.free : "N/A",
          category: app.genre || "N/A",
          developer: app.developer || "N/A",
          currency: app.currency || "N/A",
          last_updated: app.last_updated || "N/A",
          app_store_link: app.appId
            ? `https://play.google.com/store/apps/details?id=${app.appId}`
            : "#",
        };
      });
      setResults(formattedResults);
    } catch (error) {
  console.error("Error fetching search results:", error);
  setError(
    error.response && error.response.data
      ? "Failed to fetch data. Please try again."
      : "Failed to make request."
  );

    } finally {
      setLoading(false);
    }
  };

 const renderKeywordChart = (keywords, appTitle) => {
   // Use keywords directly as it's already an object
   const keywordFrequency = keywords;

   const labels = Object.keys(keywordFrequency);
   const data = Object.values(keywordFrequency);

   const chartData = {
     labels,
     datasets: [
       {
         label: "Keyword Frequency",
         data,
         backgroundColor: "rgba(75, 192, 192, 0.6)",
         borderColor: "rgba(75, 192, 192, 1)",
         borderWidth: 1,
       },
     ],
   };

   const options = {
     indexAxis: "y",
     scales: {
       x: { beginAtZero: true, title: { display: true, text: "Frequency" } },
       y: { title: { display: true, text: "Keywords" } },
     },
     responsive: true,
     plugins: {
       legend: { position: "top" },
       tooltip: {
         callbacks: {
           label: function (context) {
             return `${context.dataset.label}: ${context.raw}`;
           },
         },
       },
     },
   };

   return (
     <div
       className="chart-container"
       onClick={() => {
         setSelectedChartData(chartData);
         setModalIsOpen(true);
       }}
       style={{
         background: "rgba(255, 255, 255, 0.9)",
         borderRadius: "10px",
         padding: "15px",
         margin: "10px",
         boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
         cursor: "pointer",
       }}
     >
       <h4>{appTitle}</h4>
       <Bar data={chartData} options={options} />
       <div style={{ marginTop: "10px", fontSize: "0.8rem", color: "#666" }}>
         <div>
           <strong>X-Axis:</strong> Frequency of the Keywords
         </div>
         <div>
           <strong>Y-Axis:</strong> List of Keywords
         </div>
       </div>
     </div>
   );
 };


 const closeModal = () => {
   setModalIsOpen(false);
   setSelectedChartData(null);
 };

  return (
    <div className="container mt-4">
      {/* Box Container */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-8 border border-gray-100">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FaSearch className="mr-3 text-blue-500" />
          Keyword Research
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
          <div className="md:col-span-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">Enter Keyword</label>
            <input
              type="text"
              placeholder="Enter keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              className="w-full bg-white border border-gray-300 rounded-md py-2 px-3 text-sm text-gray-700 placeholder-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
            />
          </div>
          <div className="md:col-span-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">Select Country</label>
            <CountryList
              onSelect={(selectedCountry) => setCountry(selectedCountry)}
            />
          </div>
          <div className="md:col-span-2">
            <button
              onClick={handleSearch}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md shadow transition duration-200 flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed"
              disabled={loading}
            >
               {loading ? (
                <span className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></span>
              ) : (
                <FaSearch className="mr-2" />
              )}
              {loading ? "Searching..." : "Search"}
            </button>
          </div>
        </div>
      </div>

      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <Spinner animation="border" role="status" />
          <span className="ms-2">Loading Please Wait...</span>
        </div>
      )}
      {error && <div className="alert alert-danger">{error}</div>}

      {results.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-dark">
              <tr style={{ fontSize: "0.6rem" }}>
                <th>Screenshot</th>
                <th>App Title</th>
                <th>Keywords</th>
                <th>Installs</th>
                <th>Score</th>
                <th>Free</th>
                <th>Category</th>
                <th>Developer</th>
                <th>Currency</th>
                <th>Last Updated</th>
              </tr>
            </thead>
            <tbody>
              {results.map((app, index) => (
                <tr key={index} style={{ fontSize: "0.6rem", padding: "2px" }}>
                  <td>
                    <a
                      href={app.app_store_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={app.screenshot}
                        alt={app.title}
                        className="img-fluid rounded"
                        style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  </td>
                  <td>
                    <a
                      href={app.app_store_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "underline", color: "black" }}
                    >
                      {app.title}
                    </a>
                  </td>
                  <td>
                    <div
                      style={{
                        maxHeight: "100px", // Set the fixed height for scrolling
                        overflowY: "auto", // Enable vertical scrolling
                        padding: "5px", // Padding for spacing
                        backgroundColor: "#f2f2f2", // Light grey background for the container
                        borderRadius: "5px", // Optional: rounded corners for the container
                      }}
                    >
                      {Object.keys(app.keywords).map((keyword, index) => (
                        <span
                          key={index}
                          style={{
                            backgroundColor: "#e6e6e6", // Light grey background for each keyword
                            padding: "3px 8px", // Padding around the keyword text
                            margin: "2px", // Margin between keywords
                            borderRadius: "15px", // Rounded corners for each keyword
                            display: "inline-block", // To display keywords inline
                          }}
                        >
                          {keyword}
                        </span>
                      ))}
                    </div>
                  </td>

                  <td>{app.installs}</td>
                  <td>{app.score}</td>
                  <td>{app.free ? "Yes" : "No"}</td>
                  <td>{app.category}</td>
                  <td>{app.developer}</td>
                  <td>{app.currency}</td>
                  <td>{app.last_updated}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="row">
            {results.map((app, index) => (
              <div key={index} className="col-md-4">
                {renderKeywordChart(app.keywords, app.title)}{" "}
                {/* Pass the app title */}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Modal for enlarged chart view */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Keyword Frequency Chart"
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "transparent",
            border: "none",
            fontSize: "1.5rem",
            color: "#000",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        {selectedChartData && (
          <div>
            <Bar data={selectedChartData} />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default KeywordSearch;
